<template>
  <SiteHeader />
  <RouterView />
  <!-- <HomePage/> -->
  <SiteFooter />
</template>

<script setup>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
// import HomePage from "./views/HomePage.vue";
</script>

<style>
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Helvetica,
    Arial, "Hiragino Sans GB", sans-serif;
  background: #fff;
  color: #33475b;
  -webkit-font-smoothing: antialiased;
}

a,
a:visited,
a:hover,
a:active,
a:focus {
  text-decoration: none;
  color: #125BA8;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
